// extracted by mini-css-extract-plugin
export default {"tupacGrid":"un-z","tupacHeader":"vn-z","tupacHeader2":"wn-z","tupacMenu":"xn-z","tupacMenu2":"yn-z","tupacMain":"zn-z","tupacMain2":"An-z"};